import React, {Component} from 'react';
import CountUp from 'react-countup';
import ScrollEffect from './../../lib/scroll-effect';

export default class ImaginePossibilities extends Component {
    constructor(){
        super();
        this.handleScrollEnter = this.handleScrollEnter.bind(this);
        this.setTextNumber = this.setTextNumber.bind(this);
        this.displayCounts = this.displayCounts.bind(this);
        this.state = {
            renderedCount: false
        }
    }

    handleScrollEnter(){
        this.setState({
            renderedCount: true
        });
    }

    setTextNumber(){
        this.setState({
            renderedCount: false
        });
    }

    displayCounts(){
        const {renderedCount} = this.state;

        if(renderedCount){
            return(
                <div>
                    <div className='gr-4 imagine-possibilities-influencers'>
                        <span>
                            <CountUp
                                start={0}
                                end={14000000}
                                duration={3}
                                useEasing={true}
                                useGrouping={true}
                                callback={this.setTextNumber} />
                        </span>
                        <p>ambassadors</p>
                    </div>
                    <div className='gr-4 imagine-possibilities-reach'>
                        <span>
                            <CountUp
                                start={0}
                                end={2300000000}
                                duration={3}
                                useEasing={true}
                                useGrouping={true}
                                callback={this.setTextNumber} />
                        </span>
                        <p>potential reach</p>
                    </div>
                    <div className='gr-4 imagine-possibilities-engagement'>
                        <span>
                            <CountUp
                                start={0}
                                end={5.8}
                                decimals={1}
                                duration={3}
                                useEasing={true}
                                suffix='%'
                                callback={this.setTextNumber} />
                        </span>
                        <p>average engagement</p>
                    </div>
                </div>
            );
        } else {
            return(
                <div>
                    <div className='gr-4 imagine-possibilities-influencers'>
                        <span>
                            14 Million
                        </span>
                        <p>ambassadors</p>
                    </div>
                    <div className='gr-4 imagine-possibilities-reach'>
                        <span>
                            2.3 Billion
                        </span>
                        <p>potential reach</p>
                    </div>
                    <div className='gr-4 imagine-possibilities-engagement'>
                        <span>
                            5.8%
                        </span>
                        <p>average engagement</p>
                    </div>
                </div>
            );
        }
    }

    render(){
        const counts = this.displayCounts();

        return(
            <div
                className='gr-12 imagine-possibilities'>
                <div className='row'>
                    <div className='gr-12 imagine-possibilities-header'>
                        <h1>Imagine the possibilities...</h1>
                    </div>
                    <ScrollEffect animate="animating" callback={this.handleScrollEnter} duration={0} />
                    {counts}
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./web/js/components/brand_ambassadors/imagine_possibilities.js